// src/api/axiosClient.js
import axios from "axios";

// Create axios instance without fixed baseURL
const axiosClient = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
 
});

// Request interceptor
axiosClient.interceptors.request.use(
  (config) => {
    // Attach token dynamically if available
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
axiosClient.interceptors.response.use(
  (response) => response.data, // return only response data
  (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        // e.g., redirect or trigger re-auth
        console.warn("Unauthorized, please login again.");
      }
    } else if (error.request) {
      console.error("No response received from server.");
    } else {
      console.error("Axios setup error:", error.message);
    }
    return Promise.reject(error);
  }
);

export default axiosClient;
